export { default as Tip, TipProps } from './tip';
